import SensitiveContentConfirmModal from "js/curriculum_manager/components/modals/sensitive_content_confirm_modal"

playCollection = (playButton) ->
  window.open(playButton.attr("href"), "_blank")

showSensitiveContentConfirmModal = (onConfirm) ->
  rootEl = document.getElementById("sensitive-content-confirm-modal-root");
  if !rootEl
    rootEl = document.createElement("div")
    rootEl.id = "sensitive-content-confirm-modal-root"
    document.body.appendChild(rootEl)


  root = ReactDOM.createRoot(rootEl)

  handleSubmit = ->
    root.unmount()
    onConfirm() if onConfirm

  handleClose = ->
    root.unmount()

  root.render(
    React.createElement(SensitiveContentConfirmModal, { onSubmit: handleSubmit, onClose: handleClose })
  )

eventListenerAdded = false

bindPlayCollection = ->
  if !eventListenerAdded
    eventListenerAdded = true
    $(document).on "click", "#play-collection-btn", (e) ->
      e.preventDefault()

      playButton = $(e.target).closest("#play-collection-btn")
      isRequireTeacherAcknowledgment = playButton.data("isRequireTeacherAcknowledgment")

      if isRequireTeacherAcknowledgment
        showSensitiveContentConfirmModal(-> playCollection(playButton))
      else
        playCollection(playButton)

export { bindPlayCollection }
